import { useEffect, useState } from "react"

export function useScrollReveal(threshold = 100) {
  const [revealContent, setRevealContent] = useState(false)

  useEffect(() => {
    let ticking = false

    function handleScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          setRevealContent(window.scrollY > threshold)
          ticking = false
        })
        ticking = true
      }
    }

    window.addEventListener("scroll", handleScroll, { passive: true })
    handleScroll() // Run once on mount to set initial visibility state

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [threshold])

  return revealContent
}
